import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ClipboardList } from 'lucide-react';

declare global {
  function gtag(...args: unknown[]): void;
}

interface ViewingPlanCTAProps {
  variant?: 'button' | 'banner';
  className?: string;
}

export function ViewingPlanCTA({ variant = 'button', className = '' }: ViewingPlanCTAProps) {
  const handleClick = () => {
    if (typeof gtag === 'function') {
      gtag('event', 'viewing_plan_page_view', {
        source: variant,
      });
    }
  };

  if (variant === 'banner') {
    return (
      <div className={`bg-primary/5 border border-primary/20 rounded-lg p-4 ${className}`}>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-muted-foreground">
            Not ready yet? Get a free <span className="font-medium text-foreground">1-Day Viewing Plan</span> + checklist.
          </p>
          <Button variant="outline" size="sm" asChild onClick={handleClick}>
            <Link to="/viewing-plan" className="gap-2 whitespace-nowrap">
              <ClipboardList className="w-4 h-4" />
              Get My Plan
            </Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Button variant="outline" asChild className={className} onClick={handleClick}>
      <Link to="/viewing-plan" className="gap-2">
        <ClipboardList className="w-4 h-4" />
        Get My 1-Day Viewing Plan (Free)
      </Link>
    </Button>
  );
}
